// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/IntegrationOutboxRecord.yaml
// Generated: 2026-03-17T14:51:31.852Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { IntegrationOutboxRecord } from '@/types/integration/IntegrationOutboxRecord';

/**
 * IntegrationOutboxRecord Service (Read-Only)
 * Query operations for IntegrationOutboxRecord via the ABP API.
 */
export const integrationOutboxRecordService = new ReadOnlyEntityService<IntegrationOutboxRecord>(
  '/api/integration/integrationoutboxrecord',
  'IntegrationOutboxRecord',
);
